// MARK://dhk8/pos/lib/queries/reports
// Queries tipadas de reportes — F6.2 R3e / ADR-0008. El POS lee los read-models de
// negocio (ventas/top-productos/propinas/cortes) por el grafo desde erp-reports
// (tenant del JWT, RLS postgres-level — NUNCA tenantId como argumento). Reportes son
// read-only (proyecciones de la SAGA de eventos POS); no hay mutaciones. Campos inline
// (el preset `client` de codegen NO evalua interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosReportSalesQuery = graphql(`
  query PosReportSales($from: String, $to: String, $branchId: String) {
    reportSales(from: $from, to: $to, branchId: $branchId) {
      rows { branchId businessDate ordersCount refundsCount grossCents netCents refundedCents tipsCents }
      totals { ordersCount refundsCount grossCents netCents refundedCents tipsCents avgTicketCents }
    }
  }
`);

export const PosReportTopProductsQuery = graphql(`
  query PosReportTopProducts($from: String, $to: String, $branchId: String, $limit: Int) {
    reportTopProducts(from: $from, to: $to, branchId: $branchId, limit: $limit) {
      productId productName qty grossCents
    }
  }
`);

export const PosReportTipsQuery = graphql(`
  query PosReportTips($from: String, $to: String, $branchId: String) {
    reportTips(from: $from, to: $to, branchId: $branchId) {
      rows { branchId businessDate serverId totalCents pooledCents distributedCents }
      totals { totalCents pooledCents distributedCents }
    }
  }
`);

export const PosReportTopServersQuery = graphql(`
  query PosReportTopServers($from: String, $to: String, $branchId: String, $limit: Int) {
    reportTopServers(from: $from, to: $to, branchId: $branchId, limit: $limit) {
      serverId serverName ordersCount grossCents tipsCents
    }
  }
`);

export const PosReportCutsQuery = graphql(`
  query PosReportCuts($from: String, $to: String, $branchId: String, $limit: Int) {
    reportCuts(from: $from, to: $to, branchId: $branchId, limit: $limit) {
      cashCutId branchId businessDate shiftId kind expectedCents countedCents varianceCents cutAt
    }
  }
`);

// ── Ola 2 — paridad con el admin (IVA, métodos de pago, cancelaciones/descuentos) ──

export const PosReportPaymentMethodsQuery = graphql(`
  query PosReportPaymentMethods($from: String, $to: String, $branchId: String) {
    reportPaymentMethods(from: $from, to: $to, branchId: $branchId) {
      method count amountCents
    }
  }
`);

export const PosReportTaxesQuery = graphql(`
  query PosReportTaxes($from: String, $to: String, $branchId: String) {
    reportTaxes(from: $from, to: $to, branchId: $branchId) {
      ordersCount subtotalCents taxCents totalCents
    }
  }
`);

export const PosReportVoidsDiscountsQuery = graphql(`
  query PosReportVoidsDiscounts($from: String, $to: String, $branchId: String) {
    reportVoidsDiscounts(from: $from, to: $to, branchId: $branchId) {
      cancelledCount cancelledCents discountedOrders discountCents
    }
  }
`);

// Comparativo: solo totales del periodo (actual + anterior) — sin rows.
export const PosReportSalesTotalsQuery = graphql(`
  query PosReportSalesTotals($from: String, $to: String, $branchId: String) {
    reportSales(from: $from, to: $to, branchId: $branchId) {
      totals { ordersCount netCents }
    }
  }
`);
